module.exports = __webpack_public_path__ + "static/media/bds1__.141354bf.svg";